export interface IWhatsAppNumber {
    id: number,
    waChannelId: number,
    accountId: number,
    phoneNumberWAId: string,
    phoneNumber: string,
    verifiedName: string,
    country: string,
    createdOn: string,
    updatedOn: string,
    statusId: number
    qualityScoreId: number
    messagingLimitTierId: number
    status: IPhoneLookup
    qualityScore: IPhoneLookup
    messagingLimitTier: IPhoneLookup
    isCreationCompleted?: boolean
}

export interface INumberFormData {
    phoneNumber: string,
    countryCode: string,
    countryId: string,
    displayName: string
}

export interface IPhoneLookup {
    id: number
    name: string
    resourceKey: string
}


export type NumberListHeaderItem = {
    id: PHONE_SORT
    label: string
    sortable?: boolean
}


export enum PHONE_STATUS {
    PENDING = 1,
    DELETED = 2,
    MIGRATED = 3,
    BANNED = 4,
    RESTRICTED = 5,
    RATE_LIMITED = 6,
    FLAGGED = 7,
    CONNECTED = 8,
    DISCONNECTED = 9,
    UNKNOWN = 10,
    UNVERIFIED = 11,
}

export enum QUALITY_SCORE {
    GREEN = 1,
    YELLOW = 2,
    RED = 3,
    UNKNOWN = 4,
    NA = 5,
}

export enum PHONE_SORT {
    NUMBER = 'phoneNumber',
    STATUS = 'statusId',
    QUALITY = 'qualityScoreId',
    LIMIT = 'messagingLimitTierId',
    NAME = 'verifiedName',
    UPDATE_DATE = 'updatedOn'
}